<template>
    <div class="relative rounded-3xl bg-cover bg-center text-white w-full h-[600px] " style="background-image: url('/assets/images/header3.jpg');">
      <div class="absolute inset-0 flex flex-col justify-between px-8 py-12">
        <div class="text-left max-w-lg">
          <h1 class="text-4xl font-bold mb-2" style="font-size:50px;">
            <span class="font-semibold text-black">Find assistance,</span> <span class="font-bold text-black"> in locating an agent..</span>
          </h1>
          <p class="text-lg mb-6 text-black">Discover modern city living with our selection of premium properties all around Indonesia.</p>
        </div>
        <div>
        <div class="bg-transparent font-bold opacity-80  text-gray-800 w-full max-w-6xl mx-auto">
          <div class="flex space-x-4  ">
            <button :class="{'bg-white text-black': activeTab === 'Rent', 'bg-transparent text-gray-500': activeTab !== 'Rent'}" @click="activeTab = 'Rent'" class="px-4 py-2  rounded-tl-lg rounded-tr-lg">Find</button>
            <!-- <button :class="{'bg-white text-black': activeTab === 'Buy', 'bg-transparent text-gray-500': activeTab !== 'Buy'}" @click="activeTab = 'Buy'" class="px-4 py-2 rounded-tl-lg rounded-tr-lg">Buy</button>
            <button :class="{'bg-white text-black': activeTab === 'Sell', 'bg-transparent text-gray-500': activeTab !== 'Sell'}" @click="activeTab = 'Sell'" class="px-4 py-2 rounded-tl-lg rounded-tr-lg">Sell</button> -->
          </div>
        </div>
        <div class="bg-white font-bold opacity-80  text-gray-800 rounded-bl-lg rounded-br-lg shadow-lg p-6 w-full max-w-6xl mx-auto">
          <div class="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4">
            <select class="border text-black bg-transparent border-gray-300 rounded-lg py-2 px-4 flex-1">
              <option>Location</option>
              <option>Jakarta</option>
              <option>Bali</option>
              <!-- Add more options as needed -->
            </select>
            <select class="border text-black bg-transparent text-black bg-transparent border-gray-300 rounded-lg py-2 px-4 flex-1">
              <option>Agent Name</option>
              <option>House</option>
              <option>Apartment</option>
              <!-- Add more options as needed -->
            </select>

            <button class="bg-primary text-white rounded-lg py-2 px-6">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2h8m-8 0a9 9 0 110-18 9 9 0 010 18z" />
              </svg>
            </button>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-100 p-8">
        <h1 class="text-3xl font-bold text-gray-800">All results</h1>
        <p class="mb-6 text-gray-500">Meet our best agents near you.</p>
        <div class="grid grid-cols-3 gap-6">
            <div v-for="(agent, index) in filteredAgents"  :key="index"  class="flex items-center rounded-lg bg-white p-6 shadow">
               <div v-if="agent.image_1920">
                <img
                class="h-32 w-32 rounded-full object-cover"
                :src="`data:image/svg+xml;base64,${agent.image_1920}`"
                :alt="agent.name"
                />
                </div>
                <div v-else>
                    <div class="grid h-32 w-32 place-content-center rounded-full bg-primary text-2xl font-semibold text-white ltr:mr-2 rtl:ml-2" >
                            {{ agent.name.charAt(0) + '' + agent.name.charAt(agent.name.indexOf(' ') + 1) }}
                    </div>
                </div>
                <!-- <img class="h-32 w-32 rounded-full object-cover" src="/assets/images/person 2.jpg" :alt="agent.name" /> -->
                <div class="ml-4">
                    <h2 class="text-lg font-semibold">{{ agent.name }}</h2>
                    <!-- <p class="text-sm text-gray-500">Melati Real Estate</p> -->
                    <p class="text-sm text-gray-400">{{ agent.city ?  agent.city : '' }}</p>
                    <div class="mt-2 flex items-center">
                        <!-- <span class="text-red-500">{{ agent.rating }}</span>
                        <span class="ml-1 text-gray-400">({{ agent.reviews }})</span> -->
                    </div>
                    <button class="mt-4 rounded bg-primary px-4 py-2 text-white">Details</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, onMounted } from 'vue';
    import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogOverlay } from '@headlessui/vue';
    import Swal from 'sweetalert2';
    import { getAgentList} from '~/utils/apiService';
    useHead({ title: 'Agents' });
    import { useAuthStore } from '@/stores/authStore';
    import { getProvince } from '~/utils/apiService';
    import Multiselect from '@suadelabs/vue3-multiselect';
    import '@suadelabs/vue3-multiselect/dist/vue3-multiselect.css';
    import LoadingSpinner from '~/components/LoadingSpinner.vue';
    const agents = ref([])
    const fetchDeveloperList = async () => {
        try {
            const param = {
                name: '',
                limit: 0,
                offset: 0,
                company_id: 0,
                country_id: 0,
                state_id: 0,
            };
            const response = await getAgentList(param);
            agents.value = response.data
        } catch (error) {
            console.error('Failed to fetch countries', error);
        } finally {
        }
    };
    const filteredAgents = computed(() => {
        return agents.value.filter((agent:any) => agent.name);
    });

    onMounted(() => {
        fetchDeveloperList();
    });

</script>

<style scoped>
    /* Add any additional styles here */
</style>
